export default {
  recipients: (state) => state.recipients,
  cannedmessage: (state) => state.cannedmessage,
  cannedmessages: (state) => state.cannedmessages,
  message: (state) => state.message,
  messages: (state) => state.messages,
}
